import Vue from 'vue';
import VTooltip from 'v-tooltip';
import RegistrationApp from './RegistrationApp.vue';
import store from './store/registration';
import commonComponents from './components/registration/common';

Vue.config.productionTip = false;
Vue.use(VTooltip);

Vue.component('FormInput', commonComponents.FormInput);
Vue.component('FormFileInput', commonComponents.FormFileInput);
Vue.component('FormTextArea', commonComponents.FormTextArea);
Vue.component('FormSelect', commonComponents.FormSelect);
Vue.component('FormCheckbox', commonComponents.FormCheckbox);
Vue.component('FormCheckboxToggle', commonComponents.FormCheckboxToggle);
Vue.component('FormSwitchBoxList', commonComponents.FormSwitchBoxList);
Vue.component('PasswordStrength', commonComponents.PasswordStrength);
Vue.component('FormDateInput', commonComponents.FormDateInput);

new Vue({
  store,
  render: h => h(RegistrationApp)
}).$mount('#appRegistration');
